import { Card } from 'domain/common/components';

export const ResetPasswordVerificationCard = () => (
  <Card title="Reset your password!" iconPosition="middle">
    <p className=" mt-6 justify-center px-10 text-center text-xl ">
      We’ve sent you an email with a link to reset your password.
    </p>
  </Card>
);
